import { BackButtonComponent } from './../../../../shared/components/back-button/back-button.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnumService } from '@app/shared/components/api/services/enum.service';
import { CategoriaService } from '@app/shared/components/api/services/categoria.service';
import { AdminListaCampanhasComponent } from './components/admin-lista-campanhas/admin-lista-campanhas.component';
import { CampanhaService } from '@app/shared/components/api/services/campanha.service';
import { DashboardService } from '@app/shared/components/api/services/dashboard.service';
import { DashboardCampanhaEstadoDto } from '@app/shared/components/api/models/dashboard.model';
import { CampanhaDestaqueService } from '@app/shared/components/api/services/campanha-destaque.service';
import { ListaCampanhasDestaquesComponent } from './components/lista-campanhas-destaques/lista-campanhas-destaques.component';

@Component({
  selector: 'app-campanhas',
  imports: [
    BackButtonComponent,
    CommonModule,
    AdminListaCampanhasComponent,
    ListaCampanhasDestaquesComponent,
  ],
  providers: [
    CategoriaService,
    EnumService,
    CampanhaService,
    DashboardService,
    CampanhaDestaqueService,
  ],
  templateUrl: './campanhas.component.html',
  styleUrl: './campanhas.component.scss',
  standalone: true,
})
export class CampanhasComponent implements OnInit {
  private readonly dashboardService = inject(DashboardService);
  private readonly campanhaDestaqueService = inject(CampanhaDestaqueService);

  campanhasPorEstado: DashboardCampanhaEstadoDto[] = [];
  totalCampanhas: number = 0;
  totalDestaques: number = 0;
  selectedEstadoENUM: number | null = null;
  loadingStats: boolean = true;
  showDestacados = false;
  labelButton = 'Mostrar Destaques';

  ngOnInit(): void {
    this.getCampanhasStats();
  }

  selectEstado(estadoEnum: number | null): void {
    this.showDestacados = false;
    this.labelButton = 'Mostrar Destaques';
    if (this.selectedEstadoENUM === estadoEnum) {
      this.selectedEstadoENUM = null;
    } else {
      this.selectedEstadoENUM = estadoEnum;
    }
  }

  selectDestaques(): void {
    this.showDestacados = !this.showDestacados;

    if (this.showDestacados) {
      this.selectedEstadoENUM = null;
      this.labelButton = 'Mostrar Todos';
    } else {
      this.labelButton = 'Mostrar Destaques';
    }
  }

  showDestaques() {
    this.selectDestaques();
  }

  getCampanhasStats(): void {
    this.loadingStats = true;
    this.dashboardService.getDashboardCampanhas().subscribe({
      next: (res) => {
        this.campanhasPorEstado = res?.data || [];
        this.totalCampanhas = this.campanhasPorEstado.reduce(
          (acc, curr) => acc + (curr.total || 0),
          0,
        );
        this.loadingStats = false;
      },
      error: (err) => {
        console.error('Erro ao carregar estatísticas de campanhas:', err);
        this.loadingStats = false;
      },
    });

    this.campanhaDestaqueService
      .list({ pageSize: 1, pageNumber: 1 })
      .subscribe({
        next: (res) => {
          this.totalDestaques =
            res?.totalRecords ?? res?.total ?? (res?.data?.length || 0);
        },
        error: (err) => {
          console.error('Erro ao carregar total de destaques:', err);
        },
      });
  }

  getBadgeClass(nome: string): string {
    switch (nome?.toLowerCase()) {
      case 'em curso':
      case 'publicado':
        return 'badge-success';
      case 'pendente':
      case 'rascunho':
        return 'badge-warning';
      case 'sucesso':
      case 'concluída':
      case 'concluida':
        return 'badge-info';
      case 'recusado':
      case 'suspensa':
        return 'badge-danger';
      case 'encerrada':
        return 'badge-secondary';
      default:
        return 'badge-default';
    }
  }
}